import React from 'react';
import PropTypes from 'prop-types';

import Star from 'components/Svgs/Star';

const RatingStars = ({ quantity, className }) => (
  <div>
    {new Array(quantity).fill(null).map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Star key={`star${i}`} className={className} />
    ))}
  </div>
);

RatingStars.propTypes = {
  quantity: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default RatingStars;
